import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/RebrandedModal'
import { Text } from '@conexasaude/conexa-hero'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useHistory } from 'react-router'
import { useStyles } from './styles'

const AttendanceStartedModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()
  const { push } = useHistory()
  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()
  const styles = useStyles()

  const goAppointmentScheduled = useCallback(() => {
    closeModal()
    push('/atendimento-agendado/sala-de-espera/' + nextScheduled?.id)
  }, [nextScheduled?.id, closeModal, push])

  return (
    <Modal
      id="ATTENDANCE_STARTED"
      primaryActionLabel="Acessar consulta"
      primaryAction={goAppointmentScheduled}
      negativeActionLabel="Fechar"
      negativeAction={closeModal}
    >
      <div css={styles.wrapperModal}>
        <Text>Sua consulta começará em alguns minutos.</Text>
      </div>
    </Modal>
  )
}

export default AttendanceStartedModal
